module.exports = __webpack_public_path__ + "media/images/logo/logo_288x288-fe41bf48c98a4d4c7a74759280cce69c.png";